import GalleryGridContainer from "../../../components/miscellaneous/gallery/galleryGrid";

const GalleryGrid = () => {
  return <GalleryGridContainer />;
};

export default GalleryGrid;
